import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { UtilService } from 'src/modules/base/services/util.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { DialogRef, DialogModalSize } from "src/modules/base/components/dialog/dialog-ref";
import { LoaderService } from 'src/modules/base/services/loader.service';

@Component({
  selector: 'app-follicular-chart-grid',
  templateUrl: './follicular-chart-grid.component.html',
  styleUrls: ['./follicular-chart-grid.component.scss'],
  standalone:false
})
export class FollicularChartGridComponent {
  mobilePoints: any[] = [];
  days: number[] = [];
  yAxis: number[] = [];
  viewMobileChart = false
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  showScrollHint = false;
  tooltip = {
    visible: false,
    x: 0,
    y: 0,
    day: '',
    size: '',
    count: '',
    label: ''
  };

  labels = []
  page: any = 0;
  limit: any = 10;
  chartPlugins = []
  itemsCount: number = 0;
  fields = []
  totalDays: number = 0;
  config: any = {
    chartOptions: {
      responsive: true,
      //aspectRatio:this.utilService.isMobile()?1:2,
      maintainAsoectRatio: this.utilService.isMobile() ? false : true,
      elements: {
        line: {
          tension: 0
        }
      },
      layout: {
        padding: {
          bottom: 40
        }
      },
      scales: {
        x: {
          type: 'linear',
          min: 0,
          max: this.totalDays,
          ticks: {
            display: false,
            stepSize: 1
          },
          grid: {
            drawTicks: true,
            color: '#e0e0e0'
          }
        },
        y: {
          min: 0,
          max: 20,
          beginAtZero: true, // 1. Force the scale to start at 0
          suggestedMin: 0,
          title: {
            display: true,
            text: 'Follicle Size (mm)',
            color: '#000',
            font: {
              size: 14,
              weight: 'bold'
            }
          },

          ticks: {
            color: '#000',
            font: {
              size: this.utilService.isMobile() ? 10 : 12,
              weight: '500'
            },
            callback: function (value) {
              if (value === 18) return '>=18';
              if (value > 18) return '';
              return value;
            }
          },
        }
      },
      interaction: {
        mode: 'nearest',
        intersect: false
      },

      plugins: {
        legend: {
          display: true,
          position: 'top',
          boxWidth: 10,
          font: { size: 11 }
        },

        tooltip: {
          callbacks: {
            title: function (context) {
              const point = context[0].raw;
              return `Day ${Math.round(point.day)}`;
            },

            label: function (context) {
              const point = context.raw;

              //  use stored count (best)
              const count = point.count;

              return `${context.dataset.label}: ${count} follicle${count > 1 ? 's' : ''} (${point.y} mm)`;
            }
          }
        },
      }
    }
  }
  finalData = null
  dataGridConfig = {
    viewAll: true,
    hideSearchBox: true,
    hideResult: false,
    customButtonsAllowed: false,
    allowPagination: true,
  };
  data: {
    action: ''
  }
  constructor(public baseService: BaseService, private dialogConfig: DialogConfig, public utilService: UtilService, public loaders: LoaderService,) {

  }

  ngOnInit(): void {

    if (this.dialogConfig != undefined && this.dialogConfig.data != undefined) {
      const dialogData = this.dialogConfig?.data;
      this.data = dialogData
      if (dialogData.action === 'open_follicle_data') {

        // directly use grid data
        this.handleGridData(dialogData);

      }
      else {
        //this.chartPlugins = [this.numberRendererPlugin,this.dayLabelPlugin]
        if (!this.utilService.isMobile()) {
          this.chartPlugins = [this.numberRendererPlugin, this.dayLabelPlugin];
        }
        this.getChartData(dialogData)
      }
    }
  }

  getRadius(count) {
    const isMobile = this.utilService.isMobile();
    const isSmallDesktop = !isMobile && window.innerWidth < 1000;
    if (count < 10) {
      return isMobile ? 12 : (isSmallDesktop ? 9 : 11);
    }
    if (count < 100) {
      return isMobile ? 16 : (isSmallDesktop ? 12 : 14);
    }
    return isMobile ? 20 : (isSmallDesktop ? 15 : 16);
  }
  handleGridData(data) {

    const fieldHeadings = [
      { heading: "field.label.follicle_size", name: "rowheader" },
      { heading: "field.label.left", name: "right" },
      { heading: "field.label.right", name: "left" },
    ];

    this.fields = fieldHeadings.map((field, index) => ({
      ...field,
      order: index + 1,
      sortable: true,
      card_tag: null,

    }));
    this.bindGrid(data);
  }

  numberRendererPlugin = {
    id: 'numberRenderer',
    afterDatasetsDraw: (chart) => {
      const { ctx } = chart;

      chart.data.datasets.forEach((dataset, datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex);

        meta.data.forEach((element, index) => {
          const data = dataset.data[index];

          if (!data || !data.count) return;

          const position = element.tooltipPosition();
          const isMobile = this.utilService.isMobile();
          const isSmallDesktop = !isMobile && window.innerWidth < 1200;

          let fontSize;

          if (data.count < 10) {
            fontSize = isMobile ? 12 : (isSmallDesktop ? 10 : 11);
          } else {
            fontSize = isMobile ? 10 : (isSmallDesktop ? 9 : 10);
          }


          ctx.save();
          ctx.fillStyle = '#000';
          ctx.font = `bold ${fontSize}px Arial`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';

          ctx.fillText(data.count, position.x, position.y);

          ctx.restore();
        });
      });
    }
  };
  dayLabelPlugin = {
    id: 'dayLabelPlugin',
    afterDraw: (chart) => {
      const { ctx, scales } = chart;
      const xScale = scales.x;

      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      ctx.fillStyle = '#000';
      ctx.font = '12px Arial';

      for (let i = 0; i < this.totalDays; i++) {
        const x1 = xScale.getPixelForValue(i);
        const x2 = xScale.getPixelForValue(i + 1);

        const center = (x1 + x2) / 2;

        ctx.fillText(`Day ${i + 1}`, center, xScale.bottom);
      }
      ctx.font = 'bold 14px Arial';
      const { chartArea } = chart;
      const chartCenter = (chartArea.left + chartArea.right) / 2;

      ctx.fillText('Scan Day', chartCenter, xScale.bottom + 18);


      ctx.restore();
    }
  };
  getChartData(data) {
    let args = `uhId:${data.uhId},serviceItemCode:${data.serviceItemCode},parent_id:${data.parentId}`;
    //let filter=`no_of_days:${data?.day_no}`
    this.loaders.showSpinner();
    this.baseService.get("GET_RESULT_FOR_GRAPH", args, "stimulation_chart_details", "emr")
      .subscribe((res: any) => {

        if (res?.errCode === 0 && res?.resource?.length) {
          this.loaders.hideSpinner();
          if (this.utilService.isMobile()) {
            this.prepareMobileChart(res.resource);
            this.config.chartData = [];
          } else {
            this.prepareFollicleChart(res.resource);
          }

        } else {
          // fallback (optional)
          this.loaders.hideSpinner();
          this.config.chartData = [];

        }

      }, (err) => {
        console.error("API error", err);
        this.loaders.hideSpinner();
        this.config.chartData = [];
      });

  }
  parseSize(rowheader: string): number {

    if (!rowheader) return 0;

    const match = String(rowheader).match(/\d+/);

    return match ? Number(match[0]) : 0;
  }
  viewHint() {
    const el = this.scrollContainer?.nativeElement;

    if (!el) return;

    if (el.scrollWidth > el.clientWidth) {
      this.showScrollHint = true;

      // auto hide after 3 sec
      setTimeout(() => {
        this.showScrollHint = false;
      }, 3000);
    }

    el.addEventListener('scroll', () => {
      this.showScrollHint = false;
    });
  }
  prepareMobileChart(apiData: any[]) {
    this.viewMobileChart = true;
    this.totalDays = Number(apiData[0]?.total_days) || 7;
    const maxDays = this.totalDays;
    //const maxY = 18;
    const maxSteps = 10; // 0–20 in steps of 2 => 10 intervals

    // snap to nearest step (like chart)

    const offset = 1.5;
    this.days = Array.from({ length: maxDays }, (_, i) => i + 1);
    //this.yAxis = Array.from({ length: maxY + 1 }, (_, i) => i);
    this.yAxis = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20];
    this.mobilePoints = [];

    apiData.forEach(dayObj => {

      const day = Number(dayObj.no_of_days);

      dayObj.folliculogram.forEach(item => {

        const size = this.parseSize(item.rowheader);
        const left = Number(item.left) || 0;
        const right = Number(item.right) || 0;
        const step = Math.min(Math.floor(size / 2), maxSteps);
        // const baseY = (size / maxY) * 100;
        const baseY = (step / maxSteps) * 100;
        // LEFT
        if (left > 0) {
          this.mobilePoints.push({
            xPercent: ((day - 0.5) / maxDays) * 100 - offset,
            yPercent: baseY,
            count: left,
            size: this.getRadius(left),
            type: 'left',

            // tooltip data
            day: day,
            sizeValue: size
          });
        }

        // RIGHT
        if (right > 0) {
          this.mobilePoints.push({
            xPercent: ((day - 0.5) / maxDays) * 100 + offset,
            yPercent: baseY,
            count: right,
            size: this.getRadius(right),
            type: 'right',

            // tooltip data
            day: day,
            sizeValue: size
          });
        }

      });

    });
    setTimeout(() => {
      this.viewHint()
    }, 200)

  }
  getYPosition(value: number): number {
    const max = 20;        // full scale
    return (value / max) * 100;
  }
  hideTooltip1() {
    this.tooltip.visible = false;
  }
  showTooltip1(point, event: MouseEvent) {

    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();

    this.tooltip = {
      visible: true,
      x: rect.left + rect.width / 2,
      y: rect.top - 50,
      day: point.day,
      size: point.sizeValue,
      count: point.count,
      label: point.type === 'left' ? 'Left Ovary' : 'Right Ovary'
    };
    setTimeout(() => {
      this.tooltip.visible = false;
    }, 2000)
  }
  prepareFollicleChart(apiData: any[]) {

    const leftPoints = [];
    const rightPoints = [];
    //const totalDays = Number(apiData[0]?.total_days) || 7;
    this.totalDays = Number(apiData[0]?.total_days) || 7;
    this.config.chartOptions.scales.x.max = this.totalDays;
    //this.config.chartOptions.scales.x.max = 7
    apiData.forEach(dayObj => {

      const day = Number(dayObj.no_of_days);

      dayObj.folliculogram.forEach(item => {

        const size = this.parseSize(item.rowheader);

        const leftCount = Number(item.left) || 0;
        const rightCount = Number(item.right) || 0;
        const spread = 0.15;
        const isSmallDesktop = !this.utilService.isMobile() && window.innerWidth < 1000;
        const offset = isSmallDesktop ? 0.23 : 0.15;

        if (leftCount > 0) {
          leftPoints.push({
            x: (day - 0.5) - offset,
            //x: (day - 0.5) - offset  ,
            // x: (day - 0.5) - offset ,
            y: size,
            r: this.getRadius(leftCount),
            count: leftCount,
            day:day
          });
        }

        if (rightCount > 0) {
          rightPoints.push({
            x: (day - 0.5) + offset,
            // x: (day - 0.5) - offset   ,
            y: size,
            r: this.getRadius(rightCount),
            count: rightCount,
            day:day
          });
        }

      });

    });

    // Final datasets (NO follicleId)
    this.config.chartData = [
      {
        label: 'Left Ovary',
        data: leftPoints,
        showLine: false,
        pointRadius: 0,
        pointHoverRadius: 0,
        //pointRadius: 5,  //commented for bubble
        borderColor: '#D0E8FF',
        pointHoverBackgroundColor: '#D0E8FF',
        pointHoverBorderColor: '#D0E8FF',
        pointBackgroundColor: leftPoints.map(p =>
          p.y >= 18 ? '#DFF5E1' : '#D0E8FF'
        )
      },
      {
        label: 'Right Ovary',
        data: rightPoints,
        pointRadius: 0,
        pointHoverRadius: 0,
        showLine: false,
        //  pointRadius: 5,   //commented for bubble
        // borderColor: '#2196f3',
        // pointHoverBackgroundColor: '#2196f3',
        // pointHoverBorderColor: '#2196f3',
        // pointBackgroundColor: rightPoints.map(p =>
        //   p.y >= 18 ? 'green' : '#2196f3'
        // )
        borderColor: '#FFDDE1',   // PINK 
        pointBackgroundColor: rightPoints.map(p =>
          p.y >= 18 ? '#DFF5E1' : '#FFDDE1'
        ),
        pointHoverBackgroundColor: '#FFDDE1',
        pointHoverBorderColor: '#FFDDE1'
      }
    ];
  }

  bindGrid(data) {

    let args = `uhId:${data.uhId},serviceItemCode:${data.serviceItemCode},parent_id:${data.parentId}`;
    let filter = `no_of_days:${data?.day_no}`
    let obj = {
      page_size: this.limit,
      page_no: this.page,
      query_id: "GET_RESULT_FOR_GRAPH",
      filter: filter,
      args: args
    };
    this.baseService
      .getData(obj, "", "stimulation_chart_details", "emr")
      .subscribe((data: any) => {
        if (
          data?.errCode == 0 &&
          data?.resource != undefined &&
          data?.resource
        ) {
          let updatedData = {
            errCode: data.errCode,
            resource: data.resource[0].folliculogram,

          }
          this.finalData = updatedData;
        } else {
          this.finalData = [];
        }

      });
  }

  onLimit(event) {
    this.limit = event?.target?.value;
    this.page = 0;
    this.bindGrid(this.data);
  }
  onPageChanged(event: any) {
    this.page = event - 1;
    this.bindGrid(this.data);
  }
}


